import { pinFields } from '../consumer/contract';
import type { TemplateProjection } from '../domain/projection';
export function MissionTemplateView({ state }: { readonly state: TemplateProjection }) {
  return (
    <section aria-label="MissionTemplate result" aria-live="polite">
      <h2 data-template-status>{state.status}</h2>
      <p>SYNTHETIC · NON-OPERATIONAL · NON-AUTHORITY ({state.authority})</p>
      <p>
        MissionTemplate ≠ Mission. VERIFIED means a single-object read; it grants no operational
        permission or dependency closure.
      </p>
      {state.pin && (
        <dl data-template-pin>
          {pinFields.map((key) => (
            <div key={key}>
              <dt>{key}</dt>
              <dd data-pin-field={key}>{state.pin?.[key]}</dd>
            </div>
          ))}
        </dl>
      )}
      {state.body && (
        <>
          <p data-source-labels>
            {Array.isArray(state.body.labels) ? state.body.labels.join(' · ') : null}
          </p>
          <p>
            authorizationPoint true / false are source declarations. Neither value grants
            authorization; false does not mean no approval required, automatic authorization, or AI
            execution permission.
          </p>
          <ol data-template-stages>
            {state.stages.map((stage, index) => (
              <li key={index} data-stage-code={stage.stageCode}>
                <h3>
                  {stage.stageCode} — {stage.stageName}
                </h3>
                <p>
                  authorizationPoint:{' '}
                  <strong data-authorization-point>{String(stage.authorizationPoint)}</strong>{' '}
                  (declaration only)
                </p>
                <p>
                  {stage.authorizationPoint
                    ? 'The template declares an authorization requirement point here.'
                    : 'The source authorizationPoint declaration is false.'}
                </p>
                <details>
                  <summary>Source stage declarations and dependencies</summary>
                  <pre data-stage-content>{JSON.stringify(stage, null, 2)}</pre>
                </details>
              </li>
            ))}
          </ol>
          <h3>Unknown declarations</h3>
          <pre data-unknown-declarations>
            {JSON.stringify(state.body.unknownDeclarations, null, 2)}
          </pre>
          <details>
            <summary>Complete source body: dependencies, Unknown exposure and boundaries</summary>
            <pre data-template-body>{JSON.stringify(state.body, null, 2)}</pre>
          </details>
        </>
      )}
    </section>
  );
}
